module.exports = __webpack_public_path__ + "static/img/10-wzcc.9ba7d0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter/10-wzcc.png
// module id = Ae/a
// module chunks = 1